// extracted by mini-css-extract-plugin
module.exports = {"root":"CardWithTickList_root__Glmc1","text":"CardWithTickList_text__bORA7","list":"CardWithTickList_list__9gl05"};